/**
 * Created by ObadaDarwish on 24/05/2017.
 */

import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'truncate'
})

export class TruncatePipe implements PipeTransform {

  transform(value: string, args: string): string {
    if (args && value) {
      let limit = parseInt(args, 10) ;
      let trail = '...';

      return value.length > limit ? value.substring(0, limit) + trail : value;
    }else{
      return value;
    }
  }
}
